import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';

@modelOptions({ schemaOptions: { collection: 'policyTemplates' }, options: { customName: 'policyTemplates' } })
export class PolicyTemplatesModel {
  @prop({ required: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;

  @prop({ required: true })
  lastModified: Date;
}
